import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import Collection from "@/pages/Collection";
import { refreshInbox, useInboxSummary } from "@/lib/inbox";

// /inbox = the owner's default working page: the canonical Inbox system gallery (same queue, same rule) at a stable URL.
export default function Inbox() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const summary = useInboxSummary(!!user?.is_admin);
  const [tried, setTried] = useState(false);
  useEffect(() => { if (user?.is_admin && !summary) refreshInbox().finally(() => setTried(true)); }, [user, summary]);
  useEffect(() => { if (!loading && (!user || !user.is_admin)) navigate("/browse", { replace: true }); }, [loading, user, navigate]);
  if (loading || !user?.is_admin) return null;
  if (!summary?.collection_id) {
    return (
      <div className="min-h-screen bg-background"><Navbar />
        <div className="flex items-center justify-center py-24 text-muted-foreground" data-testid="inbox-loading">
          {tried && summary && !summary.collection_id ? "Inbox gallery is not initialised yet." : <Loader2 className="w-7 h-7 animate-spin text-primary" />}
        </div>
      </div>
    );
  }
  return <Collection cidOverride={summary.collection_id} inboxMode />;
}
